export default function Journalism({ items = [] }) {
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  return (
    <section
      id="journalism"
      data-testid="journalism-section"
      className="relative bg-[#F7F7F5] text-[#1A1A1A] py-14 md:py-20"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-8 md:mb-10 flex items-end justify-between gap-4 pb-4 border-b border-[#1A1A1A]/20">
          <div>
            <div className="flex items-center gap-3 mb-3">
              <span className="font-mono-overline">02</span>
              <span className="w-6 h-px bg-[#1A1A1A]" />
              <span className="font-mono-overline">Read</span>
            </div>
            <h2 className="font-serif-display text-2xl md:text-4xl leading-[1.08]">
              Reporting in <em className="text-[#A68661]">long & short form</em>.
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-1">
          {items.map((a, idx) => (
            <a
              key={a.id}
              data-testid={`article-${a.id}`}
              href={a.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group grid grid-cols-12 gap-3 md:gap-4 items-start py-5 border-b border-[#1A1A1A]/15 hover:bg-black/[0.02] transition-colors"
            >
              <div className="col-span-4 sm:col-span-3 md:col-span-4">
                <div className="img-zoom aspect-[4/3] bg-black/5">
                  <img
                    src={`${BACKEND_URL}/api/image-proxy?url=${encodeURIComponent(a.image_url)}`}
                    alt={a.headline}
                    loading="lazy"
                    onError={(e) => {
                      e.currentTarget.src =
                        "https://images.unsplash.com/photo-1495020689067-958852a7765e?auto=format&fit=crop&w=800&q=80";
                    }}
                  />
                </div>
              </div>
              <div className="col-span-8 sm:col-span-9 md:col-span-8">
                <div className="flex items-center gap-2 mb-1.5 text-[#1A1A1A]/60">
                  <span className="font-mono-overline text-[10px]">{a.date}</span>
                  <span className="font-mono-overline text-[10px] text-[#1A1A1A]/30 ml-auto">
                    {String(idx + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 className="font-serif-display text-base md:text-lg leading-[1.18] text-[#1A1A1A] group-hover:text-[#A68661] transition-colors line-clamp-3">
                  {a.headline}
                </h3>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
